/** Запас под кольцо фокуса — совпадает с полем `padding: 4px` ряда в `styles.ts`. */
const FOCUS_RING_GAP = 4;

/**
 * Прокручивает ряд вкладок вбок так, чтобы вкладка была видна целиком вместе с кольцом фокуса.
 *
 * Не `scrollIntoView`: он прокручивает и окно, а Chrome при фокусе не трогает частично видимую вкладку —
 * «Сборные» турнира на 1024 оставалась срезанной (IMGM-1610). Сдвигается только `scrollLeft` ряда.
 */
export function scrollTabIntoView(tab: HTMLElement, row: HTMLElement): void {
  const rowRect = row.getBoundingClientRect();
  const tabRect = tab.getBoundingClientRect();
  const left = tabRect.left - FOCUS_RING_GAP;
  const right = tabRect.right + FOCUS_RING_GAP;

  if (left < rowRect.left) {
    row.scrollLeft -= rowRect.left - left;
  } else if (right > rowRect.left + row.clientWidth) {
    row.scrollLeft += right - (rowRect.left + row.clientWidth);
  }
}
